import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import ga from '../../../analytics';
import { closeModal, isHintModalOpenSelector } from '../redux';
import './hint-modal.css'
import HintWidget from './HintWidget';


const mapStateToProps = state => ({ isOpen: isHintModalOpenSelector(state) });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { closeHintModal: () => closeModal('hint') },
    dispatch
  );

const propTypes = {
  closeHintModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  guideUrl: PropTypes.string.isRequired
};

class HintModal extends PureComponent {
  render() {
    const { isOpen, closeHintModal, guideUrl } = this.props;

    // Log the guideUrl prop for debugging
    console.log('guideUrl:', guideUrl);

    if (isOpen) {
      ga.modalview('/hint-modal');
    }

    return (
      <Modal show={isOpen} onHide={closeHintModal} dialogClassName="hint-modal modal-lg">
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>
            Hint Me!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          <HintWidget guideUrl={guideUrl} />
        </Modal.Body>
      </Modal>
    );
  }
}

HintModal.displayName = 'HintModal';
HintModal.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(HintModal);


// WEBPACK FOOTER //
// ./src/templates/Challenges/components/HintModal.js